
    <button [ngClass]="BEM" [disabled]="disabled" type="button">
      <svg *ngIf="iconLeft"><use [attr.xlink:href]="'assets/symbol/svg/sprite.css.svg' + iconLeft"></use></svg>
      <img *ngIf="imgIcon" src="{{imgIcon}}" />
      <span><ng-content></ng-content></span>
      <svg *ngIf="iconRight"><use [attr.xlink:href]="'assets/symbol/svg/sprite.css.svg' + iconRight"></use></svg>
    </button>
  